import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { fakeTicket } from '../../../../animations/keyframes';
import { colors } from '../../../../styles/constants';

export const AnimatedBackground = styled.span`
  animation-duration: 1.5s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${fakeTicket};
  animation-timing-function: linear;
  background: ${colors.loadingGradient1};
  background: linear-gradient(
    to right,
    ${colors.loadingGradient1} 8%,
    ${colors.loadingGradient2} 18%,
    ${colors.loadingGradient1} 33%
  );
  background-size: 200% 100%;
`;

const Container = styled.div`
  ${tw`w-full shadow-strong rounded-15`}
`;

const Top = styled.div`
  ${tw`p-medium flex justify-between`}
  gap:var(--size-small);
`;

const Journey = styled.div`
  ${tw`flex flex-col w-full`}
  gap:var(--size-tiny);
`;

const Price = styled(AnimatedBackground)`
  ${tw``}
  width:10%;
`;

const Bottom = styled(Top)`
  border-top: 1px solid;
  ${tw`border-grey-200`}
`;

const MainLine = styled(AnimatedBackground)`
  ${tw`w-full`}
  height: 24px;
`;

/**
 * @description Returns a loading result cards
 * @returns {JSX.Element}
 */
const LoadingCard = () => (
  <Container>
    <Top>
      <Journey>
        <MainLine />
        <MainLine />
      </Journey>

      <Price />
    </Top>

    <Bottom>
      <MainLine />
    </Bottom>
  </Container>
);

/**
 * @description Returns a list of loading result cards
 * @param {number} numberOfCards The number of cards to display
 * @returns {JSX.Element}
 */
const Loading: React.FC<{ numberOfCards: number }> = ({ numberOfCards }) => (
  <React.Fragment>
    {[...Array(numberOfCards)].map((_, index) => (
      <LoadingCard key={index} />
    ))}
  </React.Fragment>
);

export default Loading;
